import { button } from '../../../../../component/component'

export default function(o,c){

  var fwd =
    button(null,'fi-fast-forward')

  return fwd

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/fwd/fwd.js